import { api } from './api';

export const dashboardService = {
  // KPIs do MANAGER. Aceita filtros from/to (ISO).
  getStoreDashboard: async ({ from, to } = {}) => {
    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    const s = qs.toString();
    return api.get(`/api/dashboard${s ? `?${s}` : ''}`);
  }
};

export default dashboardService;
